<template lang="html">

  <div class="home wrapper">


    <section class="section intro" id="inicio">


      <div class="container">

        <h2 class="title -intro">Firma digital biométrica para formación presencial y aulas virtuales válida para formación Bonificada (FUNDAE)</h2>

        <div class="contenedor-logos row-start">
          <span class="img-container"><img src="/static/img/logo-innopulse.png" alt=""></span>
          <span class="img-container"><img src="/static/img/oca-1.png" alt=""></span>
          <span class="img-container"><img src="/static/img/oca-2.png" alt=""></span>
          <span class="img-container"><img src="/static/img/oca-3.png" alt=""></span>
          <span class="img-container"><img src="/static/img/oca-4.png" alt=""></span>
        </div>


        <div class="contenedor-descarga column-start">
          <h3>Presentación solucion</h3>
          <p>Solución de firma digitalizada para la automatización del proceso de gestión y control de formación presencial y aula virtual, que sustituye el 100% del papel (hojas de asistencia,
            recibís, cuestionarios, diplomas, etc..) y genera todas las evidencias documentales y recogidas de firmas en formato Digital.</p>
          <a target="_blank" href="https://www.iformalia.es/pdfs/comercial/Firma_Biometrica_Fundae.pdf" class="btn-rounded-blue">Descargar PDF</a>
          <a target="_blank" href="https://www.iformalia.es/pdfs/comercial/Firma_Biometrica_Fundae_Aula_Virtual.pdf" class="btn-rounded-blue">Descargar PDF</a>
        </div>

        <div class="contenedor-descarga">
          <h3>Resolución BOE</h3>
          <p>Desde la habilitación de la formación presencial el pasado Junio, ya es posible hacer uso de los mecanismos de digitalización y firma biométrica contemplados en los artículos 8 y 9 de la
            resolución.</p>
          <a target="_blank" href="https://www.iformalia.es/pdfs/comercial/ResolucionBOE_FUNDAE_Firma_Biometrica_Fundae.pdf" class="btn-rounded-blue">Descargar PDF</a>
        </div>

      </div>

      <a class="down"></a>

    </section>


    <section class="section situacion-actual" id="situacion">
      <h2 class="title -intro -green">Situación actual</h2>
      <div class="container row-start">
        <div class="contenedor-middle-text">
          <p>Con fecha de 17 de abril de 2020 se ha publicado la Resolución del Servicio Público de empleo Estatal por la que se establecen, en su ámbito de gestión, medidas extraordinarias para hacer
            frente al impacto del COVID 19 en materia de formación profesional para el empleo en el ámbito laboral.</p>
          <p><strong>El artículo 3 de este Real Decreto, indica que las acciones formativas en modalidad presencial y la parte presencial de la modalidad mixta se van a poder impartir en su totalidad
              mediante aula virtual.
            </strong></p>
        </div>
        <div class="contenedor-pasos row-between ais">
          <div class="column">
            <div class="paso">
              <h3>01</h3>
              <p>Una de la novedades importantes en esta resolución es, para la Formación Bonificada, que <strong>se permite ya la firma electrónica de los responsables de formación, formadores y
                  alumnos
                  mediante la captura de firma digitalizada</strong> o con datos biométricos. Esta firma tiene que poder realizarse en cualquiera de los documentos qué necesitan firma, asistencia,
                recibí de
                diploma, etc… y tiene que estar asociada al correspondiente NIF o NIE.</p>
            </div>
            <div class="paso">
              <h3>02</h3>
              <p><strong>Este sistema debe capturar la firma digitalizada y debe de garantizar la autenticidad de los datos</strong> correspondientes de la misma y garantizará la identidad de las
                personas firmantes.</p>
            </div>
          </div>
          <div class="column">
            <div class="paso">
              <h3>03</h3>
              <p><strong>Se permitirá el uso de medios electrónicos para garantizar la asistencia de las personas participantes</strong> siempre que quede debidamente constatada la identidad de las
                personas firmantes
                y reúna los requisitos de seguridad jurídica.</p>
            </div>
            <div class="paso">
              <h3>04</h3>
              <p>Los órganos de control (Fundae principalmente) durante las actuaciones de seguimiento, al objeto de documentar las mismas, <strong>podrán recabar la firma de las personas responsables
                  de
                  formación, personas formadoras y alumnado</strong>, en los documentos de recogida de datos, mediante captura de firma digitalizada con datos biométricos, de acuerdo con lo previsto
                en el
                artículo 8.</p>
            </div>
            <div class="paso">
              <h3>05</h3>
              <p><strong>Desaparece la hoja de firmas en papel y la asistencia</strong> pasa a estar acreditada mediante la firma digital de los alumnos.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section que-es" id="que-es">
      <h2 class="title -intro -red mb10">¿Qué es?</h2>
      <div class="container row-start">
        <p class="texto-intro">Sistema de firma digital del alumno a través de dispositivo móvil</p>
        <div class="contenedor-middle-text">
          <p><strong>El Sistema de firma digital del alumno de iformalia permite al alumno firmar su asistencia a formaciones bonificadas mediante su propio dispositivo móvil o a través del móvil o
              Tablet del formador.</strong></p>
          <p>Esta modalidad de firma junto a la gestión de la formación vía Aula Virtual son cumple rigurosamente todos los requisitos obligatorios exigidos por FUNDAE.</p>
          <p>El sistema de Firma Digital Biométrica de iformalia permite la firma biométrica y control de asistencias por parte del Formador o Responsable de la formación, garantizando el proceso,
            mediante sistemas de geolocalización e identificación de doble factor, para imposibilitar la firma por parte del alumno en caso de no estar físicamente en el aula, no realizarlo en el
            horario del curso o no haberse identificado individualmente.</p>
          <p>Esta operativa nos permitirá automatizar todo el proceso de control de presencialidad y registro de asistencia, así cómo la gestión documental <strong>digital</strong> al completo.</p>
          <p><strong>ISO/IEC 19794-7 y</strong></p>
          <p><strong>ISO/IEC 29109-7:2011</strong></p>
        </div>
      </div>


    </section>

    <section class="section que-ofrece" id="que-ofrece">
      <h2 class="title -intro mb10">¿Qué ofrece?</h2>
      <p class="texto-intro">Una propuesta integral para la gestión de la firma digital y el aula virtual</p>
      <div class="assets-que-ofrece row-center">
        <span>
          <img src="/static/img/img-aula-virtal.png" alt="Aula virtual">
          Aula Virtual
        </span>
        <span>
          <img src="/static/img/img-firma-digital.png" alt="Firma digital">
          Firma digital
        </span>
      </div>
      <div class="container arrow-tips row-center ais">
        <p><strong>Solución mediante firma digital biométrica en dispositivo móvil</strong> para el registro de la asistencia presencial de los alumnos o asistentes a cursos, eventos y actividades
          para la
          Formación Bonificada.</p>
        <p><strong>Sistema de gestión de eventos y actividades</strong> (Cursos, Seminarios, etc…) centralizado que gestiona los cursos, participantes y formadores.</p>
        <p><strong>Confirmación de recibís de materiales y diplomas</strong>, así como la realización de los cuestionarios de satisfacción (exigidos por Fundae).</p>
        <p><strong>Garantía de asistencia a los cursos</strong> presenciales y Aula Virtual, mediante un sistema de control horario y geolocalizado para sesiones presenciales e integración con la API
          de los sistemas de Aula Virtual.</p>
        <p><strong>Integración en modo consumo con cualquier plataforma del mercado</strong> (tanto de Aula Virtuales como Teams, Adobe Connect o Zoom, como de plataformas de gestión del Talento y
          RRHH SAP, SSFF, CSOD, Netex, TOTARA, Moodle…) de manera que tendremos una sincronización automática de datos (asistencias, finalizaciones automáticas de cursos y alumnos, pdfs firmados,
          reparto de costes, etc…).</p>
        <p><strong>Adaptación y personalización del sistema a las necesidades del cliente</strong> y respetando la Resolución del Servicio Público de empleo Estatal de fecha 17 de Abril.</p>
      </div>
    </section>

    <section class="section ventajas" id="ventajas">
      <h2 class="title -intro -green">Ventajas</h2>

      <div class="container contenedor-ventajas row-center ais">
        <div class="ventaja-el column-center">
          <span class="img-container">
            <img src="/static/img/ventaja-1.svg">
          </span>
          <p><strong>Automatiza las tareas administrativas</strong> (obligatorias para Fundae) que no generan valor en la empresa, reduciendo la dedicación a cada proceso y ganando tiempo para lo
            verdaderamente importante.</p>
        </div>
        <div class="ventaja-el column-center">
          <span class="img-container">
            <img src="/static/img/ventaja-2.svg">
          </span>
          <p>Mediante su API, posibilita la Centralización con el Aula Virtual de toda la información de asistencia y participación en una única aplicación y posibilita la <strong>generación de
              informes y alertas</strong> en tiempo real.</p>
        </div>
        <div class="ventaja-el column-center">
          <span class="img-container">
            <img src="/static/img/ventaja-3.svg">
          </span>
          <p><strong>Seguridad y garantía</strong> a la hora de controlar la formación presencial y la asistencia de los participantes, mediante la geolocalización y el fechado automático en el
            momento de la firma y cifrado y sellado posterior tras la firma del Formador para garantizar durabilidad e imposibilidad de alteración. Conforme a la Resolución del SEPE del pasado
            15/04/20.</p>
        </div>
        <div class="ventaja-el column-center">
          <span class="img-container">
            <img src="/static/img/ventaja-4.svg">
          </span>
          <p><strong>Seguridad, eficiencia y ahorro de costes</strong> del proceso de registro de asistencia (tanto presencial como Aula Virtual), eliminando la necesidad de contar con papel, su
            archivo y proceso de gestión (impresión de las hojas de firmas por adelantado con logotipos y modelo actualizado, cumplimentación, recogida y custodia cada día, etc…).
            Permite el cumplimiento de medidas sanitarias evitando el contacto con el papel o dispositivos de firma (pads, etc…) permitiendo a cada alumno firmar en su propio dispositivo tras la
            identificación y acceso por doble factor.</p>
        </div>
      </div>
    </section>


    <section class="section confiar" id="caracteristicas">
      <p>¿Por qué confiar en nosotros?</p>
      <div class="container contenedor-confianza row-center">
        <div class="contenedor-iconos">
          <span class="top"><img src="/static/img/icon-maxima-seguridad.svg"></span>
          <span class="right"><img src="/static/img/icon-infraestructura.svg"></span>
          <span class="bottom"><img src="/static/img/icon-validez-legal.svg"></span>
          <span class="left"><img src="/static/img/icon-confianza.svg"></span>
        </div>
        <div class="text top">
          <h3>Máxima seguridad</h3>
          <p>Comparación biométrica o por correspondencia con el QR.</p>
        </div>
        <div class="text right">
          <h3>Infraestructura de calidad</h3>
          <p>Centro de datos de Alta disponibilidad 24 x 7, con un funcionamiento garantizado del 99,5% y tiempo de restablecimiento máximo de 4 horas y pérdida de datos máxima de 15 minutos.</p>
        </div>
        <div class="text bottom">
          <h3>Validez legal</h3>
          <p>Documento electrónico con los datos biométricos del firmante y cifrado con certificado reconocido. Obligatorio en Formación Bonificada.</p>
        </div>
        <div class="text left">
          <h3>Confianza</h3>
          <p>Más de 200 proyectos tecnológicos en gestión de formación nos avalan. Amplia experiencia en gestión de Fundae.</p>
        </div>
      </div>
    </section>

    <section class="section caracteristicas">

      <div class="contenedor-slider container">

        <h2 class="title -intro -red mb10">Características</h2>

        <slick ref="slick" :options="slickOptions">

          <div class="slide">
            <p><strong>Generación del certificado de asistencia al Aula Virtual validado mediante firma digital del alumno (Formación Bonificada).</strong></p>
          </div>

          <div class="slide">
            <p><strong>Permite al alumno firmar en su móvil sin necesidad de instalar ninguna App, o acceso al correo.</strong></p>
          </div>

          <div class="slide">
            <p><strong>Garantiza la identificación del alumno, la asistencia al aula y la presencialidad en el horario del curso.</strong></p>
          </div>

        </slick>



      </div>

      <img src="/static/img/background-situacion.svg" class="background-white">
      <img src="/static/img/lupa.png" class="lupa">


    </section>

    <section class="section como-funciona" id="como-funciona">
      <h2 class="title -intro">¿Cómo funciona?</h2>

      <div class="como-funciona-container container">
        <div class="como-funciona-el">
          <span class="imagen">
            <img src="/static/img/icon-visualiza.svg" alt="">
          </span>
          <h3>Visualiza: Panel de Control interactivo</h3>
          <p>Diariamente se envía al gestor y al formador del curso un acceso securizado vía mail (para simplificar el proceso) con el estado de sus sesiones presenciales y aulas virtuales,
            asistencia, tareas pendientes, etc… Donde podrá visualizar si la planificación de la Formación (Privada y Bonificada) es correcta, dispondrá del histórico de firmas y registros de
            asistencia presencial (y de aulas virtuales) realizadas de manera automática reduciendo la dedicación a cada proceso y ganando tiempo para lo verdaderamente importante.</p>
          <div class="oculto">
            <img src="/static/img/visualiza.png">
          </div>
          <a class="js-ver-mas btn">Ver +</a>
        </div>
        <div class="como-funciona-el">
          <span class="imagen">
            <img src="/static/img/icon-firma.svg" alt="">
          </span>
          <h3>Firma</h3>
          <p>Quince minutos antes de iniciarse la sesión de formación (presencial y aula virtual), los alumnos reciben un correo electrónico con un enlace securizado (acceso por doble factor), que
            despliega una pantalla en su móvil o Tablet para que firmen con el dedo o lápiz en su dispositivo.</p>
          <p>Si no disponen del correo en su móvil, pueden escanear un código QR personalizado y securizado en el dispositivo del formador para firmar en su propio móvil si necesidad de tocar o
            compartir ningún dispositivo, papel, lápiz, etc…</p>
          <div class="oculto">
            <img src="/static/img/firma.png">
          </div>
          <a class="js-ver-mas btn">Ver +</a>
        </div>
        <div class="como-funciona-el">
          <span class="imagen">
            <img src="/static/img/icon-gestiona.svg" alt="">
          </span>
          <h3>Gestiona</h3>
          <p>15 minutos antes de la cada sesión de aula virtual, el formador recibirá un link securizado para acceder a su panel de control, pudiendo ver la planificación de sus sesiones de Formación, los QRs de firma de los alumnos en presencial, las asistencias de cada uno, puede finalizar los alumnos (aprovechamiento y asistencia, etc..) y a la finalización de cada sesión, recibirá un mail par la firma de la hoja de asistencia y validación de la actividad registrada.</p>
          <div class="oculto">
            <img src="/static/img/gestiona.png">
          </div>
          <a class="js-ver-mas btn">Ver +</a>
        </div>
        <div class="como-funciona-el">
          <span class="imagen">
            <img src="/static/img/icon-almacena.svg" alt="">
          </span>
          <h3>Almacena</h3>
          <p>Una vez que han firmado los alumnos y ha finalizado la sesión, el docente firma en la aplicación, y esta “hoja de asistencia” se envía automáticamente a un sellado de tiempo y una firma con certificado electrónico de un tercero para su cifrado, lo que impide que sea alterada y garantiza su sellado de tiempo.</p>
        </div>
      </div>

      <div class="container column-center contenedor-texto">
        <h3>Procesos simples, con garantías y automáticos</strong></h3>
        <p><strong>Proceso de Firma y Autogestión de Sesiones Presenciales:</strong> </p>
        <img src="/static/img/proceso-presencial.png" alt="">
        <p><strong>Proceso de Firma y Autogestión de Aulas Virtuales:</strong></p>
        <img src="/static/img/proceso-virtual.png" alt="">

      </div>



    </section>

    <section class="section sistema-biometrico">
      <h2 class="title -intro -green mb10">Sistema de firma biométrica</h2>
      <div class="container">
        <p class="texto-intro">¿Cómo funciona el Sistema de Firma Biométrica?</p>
        <p class="texto-intro"><strong>Iformalia utiliza un motor de firma biométrica de documentos electrónicos que incorpora un avanzado algoritmo de firma manuscrita biométrica para capturar la
            firma
            manuscrita desde dispositivos de pantalla táctil.</strong></p>

      </div>
      <div class="container row-end">
        <div class="contenedor-pasos row-end ais">
          <div class="column">
            <div class="paso">
              <h3>01</h3>
              <p>Se presenta el documento a firmar para su revisión y se informa de que va a firmar la asistencia a la sesión, el anexo de solicitud, el recibí de diploma o cualquier otro documento
                que se organice en el proceso.</p>
            </div>
            <div class="paso">
              <h3>02</h3>
              <p>Se muestra el panel de firma para que el alumno trace su firma y el dispositivo capture sus datos biométricos.</p>
            </div>
            <div class="paso">
              <h3>03</h3>
              <p>Se genera y visualiza el documento que contiene la información capturada vinculada al contenido del documento.</p>
            </div>
            <div class="paso">
              <h3>04</h3>
              <p>Se custodia y sella el documento.</p>
            </div>
            <p><strong>La custodia segura de documentos es una de las utilidades más importantes de la firma biométrica. Su uso se convertirá en estándar para la Formación Bonificada, los Planes de
                Formación Estatal y Autonómicos para Desempleados y Ocupados. Empezando a ser usada estos días para que la Formación mediante Aula Virtual pueda ser bonificable (tendrá consideración
                de modalidad Presencial).</strong></p>
          </div>
        </div>
      </div>
    </section>

    <section class="section compatibilidad">

      <div class="container column-center">
        <h2 class="title -intro -red mb10">Compatibilidad</h2>
        <div class="contenedor-imagenes row-start">
          <span><img src="/static/img/abode-connect.png" alt="Adobe Connect"></span>
          <span><img src="/static/img/google-hangouts.png" alt="Google Hangouts"></span>
          <span><img src="/static/img/cisco.png" alt="Cisco Webex"></span>
          <span><img src="/static/img/moddle.png" alt="Moddle"></span>
          <span><img src="/static/img/zoom.png" alt="Zoom"></span>
          <span><img src="/static/img/gotomeeting.png" alt="Go to meeting"></span>
          <span><img src="/static/img/teams.png" alt="Microsoft Teams"></span>
          <span><img src="/static/img/skype.png" alt="Skype"></span>
        </div>
      </div>

    </section>

    <section class="section contacto" id="contacto">
      <h2 class="title -intro mb10">Contáctanos</h2>
      <p>¿Quieres más información? ¿Probar una demo? Escríbenos y nos pondremos en contacto contigo</p>
      <contacto></contacto>
    </section>





  </div>

</template>

<script lang="js">


  import contacto from '@/components/view-parts/contacto/formulario';

  import Slick from 'vue-slick';

  export default  {
    name: 'home',
    components : {
      'contacto' : contacto,
      Slick
    },
    data(){
      return{
        slickOptions: {
          slidesToShow: 1,
          arrows : true,
          dots : true
        },
      }
    },
    mounted(){
      $(".js-ver-mas").click(function(){
        let oculto = $(this).parent().find('.oculto');

        oculto.toggle();

        if(oculto.attr('style').includes('block')){
          $(this).html("Ver -");
        }else{
          $(this).html("Ver +");
        }

      })
    }
  }
</script>

<style scoped>

.full-intro{
  height: auto;
  min-height: 75vh;
  width: 100%;
  background: #f3f7fb;
  margin-bottom: 40px;
}

.waypoints{
  -webkit-animation-delay: 1s;
  -o-animation-delay: 1s;
  animation-delay: 1s;
}
@media screen and (max-width: 600px){
  .full-intro{
    min-height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/home.vue